import React, { useState } from "react";
import toast from "react-hot-toast";
import {
  useCreateOrderMutation,
  useCreateReservationMutation,
} from "../../Store/Apis/bookingApi";
import { useNavigate } from "react-router-dom";
import AddEditBooking from "../../Components/AddEditBooking/AddEditBooking";

const NewSale = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [createOrder, createOrderResponse] = useCreateReservationMutation();
  const handlePlaceOrder = async (orderData) => {
    if (isSubmitting) return; // block duplicate clicks
    setIsSubmitting(true);
    try {
      const res = await createOrder(orderData);
      if (res?.data?.status === 200) {
        toast.success(res?.data?.message, { duration: 7000 });
        navigate("/sales-history");
      } else {
        toast.error(res?.data?.message || "Booking failed", { duration: 7000 });
      }
    } catch (err) {
      console.log(err);
      toast.error("Something Went Wrong !!", { duration: 7000 });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <AddEditBooking onSubmit={handlePlaceOrder} isSubmitting={isSubmitting} />
    </div>
  );
};

export default NewSale;
